//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    let ASN_STATUS = {
      /**
       * 状态：草稿
       */
      STATE_DRAFT: 'DRAFT',
      /**
       * 状态：待发货
       */
      STATE_TO_BE_DELIVERED: 'TO_BE_DELIVERED',
      /**
       * 状态：已发货
       */
      STATE_TO_BE_RECEIVED: 'TO_BE_RECEIVED',
      /**
       * 状态：已收货
       */
      STATE_RECEIVED: 'RECEIVED',
      /**
       * 状态：已废弃
       */
      STATE_ABANDONED: 'ABANDONED',
    };
    let any;
    return {
      detailId: null,
      dto: {},
      isSupplier:false,
      selectModel:'base',
      enableBarCode : false,
      loginData : {},
      ASN_STATUS : ASN_STATUS,
      customStatus: any = [],
      asn:{
        orderDetails: [],
        enableEdit: false,
        lastModifiedBy: null,
        lastModifiedName: null,
        enableDelete: false,
      },
      person: any,
      checked:'',
      checkList:[]
    }
  },
  methods: {
    getCurrent(){
      this.$get('api/person/current').then((res) => {
        this.loginData.name = res.name;
      })
    },
    getDetail() {
      this.$loadingShow();
      this.$get('api/asn/' + this.detailId).then((data) => {
        this.dto = data;
        this.$loadingHide();
        this.initData();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    recall(){
      this.$get('api/asn/recallById/' + this.detailId + "?id=" + this.detailId ).then((data) => {
        this.$message({
          message: '撤回成功',
          type: 'success'
        });
        this.$router.replace("/asn/asn-list");
      }).catch(() => {
        this.$loadingHide();
      })
    },
    isSupplierUrl(){
      this.$get('api/supplier/is-supplier').then((data) => {
        this.isSupplier = data;
        console.log(this.isSupplier);
      }).catch(() => {
        this.$loadingHide();
      })
    },
    changeShowModel(str){
      this.selectModel = str;
    },
    backSourceList() {
      this.$router.go(-1);
    },
    switchTabItem(orderDetail,i){
      this.$set(orderDetail,'list',i);
    },
    changeSup(dto) {
      if (dto.show) {
        this.$set(dto,'show',false);
        return;
      }
      this.$set(dto,'show',true);
    },
    goEdit(){
      //编辑
      this.$router.push("/asn/edit/"+ this.detailId);
    },
    initData() {
      if (this.dto.status == 'DRAFT'&& (this.loginData.name == this.dto.createdBy || this.loginData.name == this.dto.founderName)){
        // 允许编辑
        this.asn.enableEdit=true;
      }
      if(this.dto.status == 'TO_BE_RECEIVED'&& (this.loginData.name == this.dto.createdBy || this.loginData.name == this.dto.founderName)){
        this.asn.enableDelete=true;
        if (this.dto.orderDetails) {
          this.dto.orderDetails.forEach((item) => {
            if (item.receiveQty && item.receiveQty > 0) {
              this.asn.enableDelete = false;
            }
          });
        }
      }
    },
    asnDelete(){
      this.$confirm('此操作将永久删除该送货单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass:'messageBox'
      }).then(() => {
        this.$del('api/asn/' + this.detailId).then((data) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.$router.replace("/asn/asn-list");
        }).catch(error => {
          this.$message.error('数据提交失败!');
          console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });


    },
    changeBox(){
      let checkListGroup = [];
      let count = 0;
      for (let i=0;i<this.dto.orderDetails.length;i++){
        if(this.dto.orderDetails[i].checked == true){
          checkListGroup.push(this.dto.orderDetails[i]);
          count++;
        }
      }
      this.checkList= checkListGroup;
      console.log(count);
      console.log(this.checkList)
      console.log(event.target.checked);
    },
    deleteDetails(detail){
      //删除明细行数据
      if(this.checkList.length<1){
        this.$message.error('至少选择一条记录！');
        return;
      }
      this.checkList.forEach(temp => {
        if (temp.id) {
          // 已经存储到后台，进行标记删除
          temp.deleted = true;
        } else {
          this.dto.detailTable.data = this.dto.detailTable.data.filter(item => item != temp);
        }
      });
      let ordersSet = new Set();
      let ids = [];
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].receiveQty && this.checkList[i].receiveQty != 0) {
          this.$message.error('存在送货单行项目已收货,不允许整单删除!');
          return;
        }
        if (this.checkList[i].purOrderErpNo) {
          ordersSet.add(this.checkList[i].purOrderErpNo);
        }
        ids.push(this.checkList[i].id);
      }
      this.$del('api/asn/' + ids).then((data) => {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.$router.replace("/asn/asn-list");
      }).catch(error => {
        this.$message.error('无权限操作!');
        console.log(error);
      })

    }
  },
  mounted() {
    this.detailId = this.$route.params.id;
    this.getDetail();
    this.isSupplierUrl();
  },
}



// WEBPACK FOOTER //
// ./src/page/asn/view/view.vue